<div class="limits">
  <div class="w-full flex justify-between md:block flex-none md:w-auto mb-[6px] md:mb-0">
    <p>
      <strong>
        {{ 'recurring-buy.your_limits_on_coinmate' | translate }}
      </strong>
    </p>
    <p>
      <a [routerLink]="'/verification'" class="link">
        {{ 'Increase limits' | translate }}
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.66699 3.33268H5.86699C4.74689 3.33268 4.18683 3.33268 3.75901 3.55067C3.38269 3.74242 3.07673 4.04838 2.88498 4.4247C2.66699 4.85252 2.66699 5.41258 2.66699 6.53268V10.1327C2.66699 11.2528 2.66699 11.8128 2.88498 12.2407C3.07673 12.617 3.38269 12.9229 3.75901 13.1147C4.18683 13.3327 4.74689 13.3327 5.86699 13.3327H9.46699C10.5871 13.3327 11.1471 13.3327 11.575 13.1147C11.9513 12.9229 12.2573 12.617 12.449 12.2407C12.667 11.8128 12.667 11.2528 12.667 10.1327V8.33268M13.3337 2.66602L8.00033 7.99935M13.3337 2.66602V5.66602M13.3337 2.66602H10.3337"
            stroke="#3E68FF"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </a>
    </p>
  </div>
  <div>
    <p>{{ 'recurring-buy.daily_limit' | translate }}</p>
    <p>
      <strong>{{ user24hLimit || 0 | appCurrencyFloor : currencyCode | async }} {{ currencyCode }}</strong>
    </p>
  </div>
  <div>
    <p>{{ 'recurring-buy.monthly_limit' | translate }}</p>
    <p>
      <strong>{{ user30dLimit || 0 | appCurrencyFloor : currencyCode | async }} {{ currencyCode }}</strong>
    </p>
  </div>
</div>
